// swiper index
//=============
(function () {
    let swiperSelector = document.querySelector('.JS-index-slider-swiper');
    if(typeof(swiperSelector) === 'undefined' || swiperSelector === null)
        return;

    let swiperIndex = new Swiper(swiperSelector, {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        }
    });
}());